import React, {useState,useEffect} from 'react';
import { useTranslate } from 'react-redux-multilingual'
import {CardPerso} from '@gull'
import axios from 'axios'
import apiCallCompta_correspondance from './Comp/apiCallCompta_correspondance'
import SubmitAndSelectTypeCorrespondence from './Comp/SubmitAndSelectTypeCorrespondence'
import TaxeVentilationArticleSelect from './Comp/TaxeVentilationArticleSelect'
import ArticleVentilationForm from './Comp/ArticleVentilationForm'

const CodeConfigurationTaxe = (props) => {
    const t = useTranslate();

    //Détermine le nom de la catégorie de TVA appliquée à l'entité courante (société ou other_company)
    const categorieTvaName = props.idCompany=='company'
        ? props.company.categorie_tva
        : (props.company.other_company || []).find(value=>value.id==props.idCompany)?.categorie_tva;

    //Récupère les taux de la catégorie appliquée, sinon on garde le comportement historique (tous les taux de la société)
    const categorieTvaApplied = categorieTvaName
        ? (props.authParam.company.advanceparams.categorie_tva || []).find(value=>value.name===categorieTvaName)
        : null;

    const applicableTauxTgc = (categorieTvaApplied && categorieTvaApplied.taux!=null)
        ? categorieTvaApplied.taux
        : props.authParam.company.advanceparams.taux_tgc;

    const [correspondenceTaxeValue,setCorrespondenceTaxeValue] = useState({})
    const [ventialtionArticleTaxeValue,setVentialtionArticleTaxeValue] = useState({})
    const [disabledBtn,setDisabledBtn] = useState(false)
    const [validButton,setValidButton] = useState(false)

    const [ventilationArticleType,setVentilationArticleType] = useState('') //Sélection du type de ventilation : fournisseur, classification, nom du parrent, ...
    const [ventilationFieldName,setVentilationFieldName] = useState('') //Nom du champ de la ventilation à ajouter 
    const [ventilationSelectDatas,setVentilationSelectDatas] = useState(false)//les datas affichées dans le select d'ajout d'une nouvelle ligne de ventilation
    const [initIsFinish,setInitIsFinish] = useState(false)//Permet de savoir si l'initialisation est fini pour le mode ventilation par article

    useEffect(function () {
        //gère les input des taxes et ventilation dans si la ventilation par article est choisit 
        //On vérifie d'abord si une configuration avec ventilaiton par article existe
        if(props.ventilationType=='article'){
            //Cela veut dire qu'une configuration du fichier B2b, B2c ou achat à été fait 
            //On laisse alors le user définir sa ventilation par article pour la TGC
            //Si il y a uen configuration avec ventilation par article
            if(props.detailConfig && props.selectType==props.detailConfig.type && props.detailConfig.hasOwnProperty('article') && props.detailConfig.article!=null){                
                let objTaxeCollecte = {}
                let objVentilationInit = {}
                applicableTauxTgc.map(tauxTaxe=>{
                    //Partie qui concerne que la collecte et recette
                    //ici on ne renseigne que la collecte car la ventilation remplace la recette, mais on met quand meme un chaine vide à recette pour que si le user change de config 
                    //et passe en config sans ventilation, qu'il puisse faire ses modificaitons
                    if((props.detailConfig.article.collecte || {})[tauxTaxe]){
                        objTaxeCollecte[tauxTaxe]={
                            collecte:{
                                numero: props.detailConfig.article.collecte[tauxTaxe].numero,
                                libelle: props.detailConfig.article.collecte[tauxTaxe].libelle
                            }
                        }
                    }

                    //Partie qui concerne la ventilation par article
                    let arr = [
                        {
                            fieldName:'default',
                            code:(props.detailConfig.article.config.default || {})[tauxTaxe] ? props.detailConfig.article.config.default[tauxTaxe].numero : '',
                            libelle:(props.detailConfig.article.config.default || {})[tauxTaxe] ? props.detailConfig.article.config.default[tauxTaxe].libelle : ''
                        }
                    ]
                    if(props.selectType=='vente_b2c'){
                        arr.push({
                            fieldName:'giftcard',
                            code:(props.detailConfig.article.gift_card || {})[tauxTaxe] ? props.detailConfig.article.gift_card[tauxTaxe].numero : '',
                            libelle:(props.detailConfig.article.gift_card || {})[tauxTaxe] ? props.detailConfig.article.gift_card[tauxTaxe].libelle : ''
                        })
                    }
                    Object.entries(props.detailConfig.article.config).map(([fieldName,values])=>{
                        //On ignore default car on souhaite placer default et gift card ne première position
                        if(fieldName!='default'){
                            arr.push({
                                fieldName:fieldName, 
                                code:values[tauxTaxe] ? values[tauxTaxe].numero : '', 
                                libelle:values[tauxTaxe] ? values[tauxTaxe].libelle : ''
                            })
                        }
                    })
                    
                    objVentilationInit[tauxTaxe]=arr
                })
                if(props.detailConfig.article.hasOwnProperty('field')) setVentilationArticleType(props.detailConfig.article.field)
                setCorrespondenceTaxeValue(objTaxeCollecte)
                setVentialtionArticleTaxeValue(objVentilationInit)
            }else{
                let objVentilationInit = {}
                let objTaxeCollecte = {}
                applicableTauxTgc.map(txTaxe=>{ //props.detailConfig ? props.detailConfig.mode_paiement[value].numero :
                    objTaxeCollecte[txTaxe]={
                        collecte:{
                            numero: '',
                            libelle: ''
                        }
                    }
                    
                    let arr = [{fieldName:'default', code:'', libelle:''}]
                    if(props.selectType=='vente_b2c'){ 
                        arr.push({fieldName:'giftcard', code:'', libelle:''})
                    }
                    
                    objVentilationInit[txTaxe]=arr
                })
                setVentialtionArticleTaxeValue(objVentilationInit)
                setCorrespondenceTaxeValue(objTaxeCollecte)
            }
            
        }else{
            if(applicableTauxTgc!=null){
                let objTaxeCollecteRecette = {}

                applicableTauxTgc.map(tauxTaxe=>{
                    objTaxeCollecteRecette[tauxTaxe]={
                        recette:{
                            numero: (props.detailConfig && props.selectType==props.detailConfig.type &&  props.detailConfig.hasOwnProperty('taxe') && props.detailConfig.taxe!=null && props.detailConfig.taxe[tauxTaxe]) ? 
                                props.detailConfig.taxe[tauxTaxe].recette.numero 
                            : 
                                '',
                            libelle: (props.detailConfig && props.selectType==props.detailConfig.type &&  props.detailConfig.hasOwnProperty('taxe') && props.detailConfig.taxe!=null && props.detailConfig.taxe[tauxTaxe]) ? 
                                props.detailConfig.taxe[tauxTaxe].recette.libelle 
                            : 
                                ''
                        },
                        collecte:{
                            numero: (props.detailConfig && props.selectType==props.detailConfig.type &&  props.detailConfig.hasOwnProperty('taxe') && props.detailConfig.taxe!=null && props.detailConfig.taxe[tauxTaxe]) ? 
                                props.detailConfig.taxe[tauxTaxe].collecte.numero 
                            : 
                                '',
                            libelle: (props.detailConfig && props.selectType==props.detailConfig.type &&  props.detailConfig.hasOwnProperty('taxe') && props.detailConfig.taxe!=null && props.detailConfig.taxe[tauxTaxe]) ? 
                                props.detailConfig.taxe[tauxTaxe].collecte.libelle 
                            : 
                                ''
                        }
                    }
                })
                
                setCorrespondenceTaxeValue(objTaxeCollecteRecette)
            }
        }
    }, [props.detailConfig,props.ventilationType,props.selectType])

    useEffect(function () {
        if(initIsFinish && props.ventilationType=='article'){
            //Quand on change de type de ventilation, il faut retirer toutes les lignes ajoutés qui concerne l'ancien type
            let obj = {}
            Object.entries(ventialtionArticleTaxeValue).map(([txTaxe,datas])=>{
                //On garde que la première ligne car elle correspond au champ par défaut 
                //Et ma 2eme si on est sur du b2c pour les giftcards
                if(datas[1] && datas[1].fieldName=='giftcard'){
                    obj[txTaxe]=[datas[0],datas[1]]
                }else{
                    obj[txTaxe]=[datas[0]]
                }
            })
            setVentialtionArticleTaxeValue(obj)
        }
    }, [props.ventilationType,ventilationArticleType])

    useEffect(function () {
        //Gestion des donnée à afficher dans de select qui permet d'ajouter un nouvelle ligne de ventilation par article
        if(props.ventilationArticleDatas.length!=0 && Object.keys(props.liaison).length!=0 && ventilationArticleType!=''){
            //on récupère ici la ventilation des données à afficher 
            let ventilationConfig = props.ventilationArticleDatas.find(value => value.data == ventilationArticleType)
            if(ventilationConfig.list!='liaison' && ventilationConfig.list!='free'){
                //Dans le cas de données non libre de customField
                setVentilationSelectDatas(ventilationConfig.list)
            }else if(ventilationConfig.list=='liaison'){
                setVentilationSelectDatas(props.liaison[ventilationArticleType].map(value=>value.name))
            }else{
                //CustomField ou donnée qui sont libre 
                setVentilationSelectDatas(false)
            }
        }
    }, [ventilationArticleType,props.ventilationArticleDatas,props.liaison])

    useEffect(function () {
        if(Object.keys(correspondenceTaxeValue).length!=0){
            setDisabledBtn(false)

            let disabledBtn;

            Object.entries(correspondenceTaxeValue).map(([taxeTx,value])=>{
                if(props.ventilationType=='article'){
                    //Si la ventilation par article est activée, on affiche pas la recette 
                    if(value.collecte.numero=='' || value.collecte.libelle=='') disabledBtn = true
                }else{
                    if(value.collecte.numero=='' || value.collecte.libelle=='' || value.recette.numero=='' || value.recette.libelle=='') disabledBtn = true
                }
            })

            if(props.ventilationType=='article'){
                if(ventilationArticleType=='') disabledBtn = true
                Object.entries(ventialtionArticleTaxeValue).forEach(([taux, fields]) => {
                    fields.forEach(({ fieldName, code, libelle }) => {
                        if(fieldName=='default' && (code=='' || libelle=='')) disabledBtn = true
                    });
                });
            }

            setDisabledBtn(disabledBtn)
        }
    }, [correspondenceTaxeValue,ventialtionArticleTaxeValue,ventilationArticleType])

    const handleChange = (e, taxeTx, correspondance, input) => {
        setCorrespondenceTaxeValue(prev => {
            const taxeEntry = prev[taxeTx] || {};
            const correspondanceEntry = taxeEntry[correspondance] || {};

            return {
                ...prev,
                [taxeTx]: {
                    ...taxeEntry,
                    [correspondance]: {
                        ...correspondanceEntry,
                        [input]: e.target.value
                    }
                }
            };
        });
    };

    const addNewVentilationField = (newField) => {
        let obj = {}
        //On ajoute la nouvelle ligne pour chaque card de de TGC
        applicableTauxTgc.map(txTaxe=>{
            obj[txTaxe]=[
                ...ventialtionArticleTaxeValue[txTaxe],
                {fieldName:newField, code:'', libelle:''},
            ]
        })

        setVentialtionArticleTaxeValue(obj)
        setVentilationFieldName('')
    };

    const handleSubmit = () => {    
        let axiosAction = props.detailConfig ? axios.put : axios.post
        let configId = props.detailConfig ? '/'+props.detailConfig.id : ''

        let obj = {
            type:props.selectType
        }
        if(props.idCompany!='company') obj["other_company"]=props.idCompany

        if(props.ventilationType=='article'){
            let ventilationObjConfig = {};
            let collecteObj = {};
            let giftcardObj = {};

            Object.entries(ventialtionArticleTaxeValue).forEach(([taux, fields]) => {
                fields.forEach(({ fieldName, code, libelle }) => {
                    if(fieldName!='giftcard' && code!='' && libelle!=''){
                        if (!ventilationObjConfig[fieldName]) {
                            ventilationObjConfig[fieldName] = {};
                        }
                        ventilationObjConfig[fieldName][taux] = {
                            numero: code,
                            libelle: libelle
                        };
                    }else if(props.selectType=='vente_b2c' && fieldName=='giftcard' && code!='' && libelle!=''){
                        if (!giftcardObj[taux]) {
                            giftcardObj[taux] = {};
                        }
                        giftcardObj[taux] = {
                            numero: code,
                            libelle: libelle
                        };
                    }
                });
            });

            Object.entries(correspondenceTaxeValue).forEach(([taux, fields]) => {
                if (!collecteObj[taux]) {
                    collecteObj[taux] = {};
                }
                collecteObj[taux] = {
                    numero: fields.collecte.numero,
                    libelle: fields.collecte.libelle
                };
            });

            let initObj = {
                field: ventilationArticleType,
                config: ventilationObjConfig,
                collecte:collecteObj,
            }
            if(props.selectType=='vente_b2c') initObj['gift_card'] = giftcardObj

            obj['article'] = initObj
        }else{
            obj['taxe'] = correspondenceTaxeValue
        }

        apiCallCompta_correspondance(setValidButton,axiosAction,obj,t,configId,props.setReload)
    };

    return(<>
        <SubmitAndSelectTypeCorrespondence
            disabledBtn={disabledBtn}
            validButton={validButton}
            handleSubmit={handleSubmit}
            selectType={props.selectType}
            setSelectType={props.setSelectType}
            config={props.config}
            setReload={props.setReload}
            company={props.company}
            setVentilationArticleType={setVentilationArticleType}
            setVentilationSelectDatas={setVentilationSelectDatas}
            idCompany={props.idCompany}
        />
        {props.ventilationType=='article' &&
            <ArticleVentilationForm 
                authParam={props.authParam}
                ventilationType={props.ventilationType}
                ventilationArticleDatas={props.ventilationArticleDatas}
                ventilationArticleType={ventilationArticleType}
                setVentilationArticleType={setVentilationArticleType}
                loadingTypeConf={props.loadingTypeConf}
                ventilationSelectDatas={ventilationSelectDatas}
                ventilationFieldName={ventilationFieldName}
                setVentilationFieldName={setVentilationFieldName}
                addNewVentilationField={addNewVentilationField}
                setVentilationSelectDatas={setVentilationSelectDatas}
                setInitIsFinish={setInitIsFinish}
            />
        }
        {props.ventilationType=='tgc' || Object.keys(ventialtionArticleTaxeValue).length!=0 ?
            <div className='row'>
                {props.ventilationType=='article' && ventilationArticleType=='' ?
                    <></>
                :
                    applicableTauxTgc!=null && applicableTauxTgc.map(taux=>{
                        return(
                            <div key={taux} className="col-4">
                                <CardPerso header={props.authParam.company.nomenclature_tgc+' '+taux+'%'}>
                                    {props.ventilationType=='tgc' ?
                                        <div className="row mb-1">
                                            <label className='text-center mb-1 fw-bold'>{t('receipts')}</label>
                                            <div className="col-6 form-group">
                                                <label>Code</label>
                                                <input 
                                                    disabled={validButton}
                                                    value={correspondenceTaxeValue[taux]?.recette?.numero || ''} 
                                                    type="text" 
                                                    className='form-control' 
                                                    onChange={(e)=>handleChange(e,taux,'recette','numero')} 
                                                />
                                            </div>
                                            <div className="col-6 form-group">
                                                <label>{t('wording')}</label>
                                                <input 
                                                    disabled={validButton}
                                                    value={correspondenceTaxeValue[taux]?.recette?.libelle || ''} 
                                                    type="text" 
                                                    className='form-control' 
                                                    onChange={(e)=>handleChange(e,taux,'recette','libelle')} 
                                                />
                                            </div>
                                        </div> 
                                    :
                                        <TaxeVentilationArticleSelect 
                                            ventilationArticleType={ventilationArticleType}
                                            // ventilationArticleDatas={props.ventilationArticleDatas}
                                            ventilationConfig={props.ventilationArticleDatas.find(value => value.data == ventilationArticleType)}
                                            liaison={props.liaison}
                                            ventialtionArticleTaxeValue={ventialtionArticleTaxeValue}
                                            setVentialtionArticleTaxeValue={setVentialtionArticleTaxeValue}
                                            taux={taux}
                                            authParam={props.authParam}
                                            validButton={validButton}
                                        />
                                    }   
                                    <hr />
                                    <div className="row">
                                        <label className='text-center mb-1 fw-bold'>{t('collection')}</label>
                                        <div className="col-6 form-group">
                                            <label>Code</label>
                                            <input 
                                                disabled={validButton}
                                                value={correspondenceTaxeValue[taux]?.collecte.numero || ''} 
                                                type="text" 
                                                className='form-control' 
                                                onChange={(e)=>handleChange(e,taux,'collecte','numero')} 
                                            />
                                        </div>
                                        <div className="col-6 form-group">
                                            <label>{t('wording')}</label>
                                            <input 
                                                disabled={validButton}
                                                value={correspondenceTaxeValue[taux]?.collecte.libelle || ''} 
                                                type="text" 
                                                className='form-control' 
                                                onChange={(e)=>handleChange(e,taux,'collecte','libelle')} 
                                            />
                                        </div>
                                    </div>
                                </CardPerso>
                            </div>
                        )
                    })
                }
            </div>
        :
            <div className="mt-3 d-flex justify-content-center"><div className="spinner-border spinner-border-sm"></div></div>
        }
    </>
    )
}

export default CodeConfigurationTaxe;